export const success = {
  wrapper: 'flex flex-col items-center justify-center',
  title: {
    base: 'text-3xl font-bold mb-8 text-transparent bg-clip-text',
    gradient: 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20'
  },
  content: {
    wrapper: 'space-y-4 text-sm leading-relaxed max-w-lg',
    text: {
      base: 'text-cyan-100/70',
      highlight: 'text-cyan-400 font-semibold'
    }
  },
  uploadStatus: {
    wrapper: 'absolute top-4 left-0 right-0 flex flex-col items-center',
    text: 'text-sm text-cyan-400/80 mb-2',
    progressBar: {
      wrapper: 'w-64 h-1 bg-gray-800 rounded-full overflow-hidden',
      fill: 'h-full bg-gradient-to-r from-cyan-500 to-blue-500 transition-all duration-300'
    }
  },
  error: {
    text: 'mb-4 text-sm text-red-400 text-center'
  }
} 